import { ArrowRight } from 'lucide-react'
import { useState, type FormEvent } from 'react'
import { Link, Navigate, useLocation } from 'react-router'

import { mensajeDeEntrada } from '../api/cuenta'
import { useEntrar, useSesion } from '../api/sesion'
import { PantallaDeAcceso } from '../componentes/Acceso'
import { Aviso, Boton, Campo } from '../componentes/ui'
import { marca } from '../marca/marca'

/**
 * Entrar. La contraseña va al núcleo y vuelve una cookie `HttpOnly`: aquí no se
 * guarda nada, ni se mira el token que trae la respuesta.
 *
 * Tras cinco intentos malos el núcleo bloquea la entrada diez minutos; eso se dice como
 * lo que es, no como «contraseña incorrecta» (que también lo diría con la buena).
 */
export const Entrar = () => {
  const { usuario, cargando } = useSesion()
  const { state } = useLocation()
  const entrar = useEntrar()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const volver = typeof (state as { volver?: unknown })?.volver === 'string' ? (state as { volver: string }).volver : '/'
  if (!cargando && usuario) return <Navigate replace to={volver} />

  const enviar = (e: FormEvent) => {
    e.preventDefault()
    entrar.mutate({ email, password })
  }

  const mensaje = mensajeDeEntrada(entrar.error)

  return (
    <PantallaDeAcceso>
      <form onSubmit={enviar}>
        <h1 className="font-display text-[28px] font-semibold tracking-tight">Entra en tu panel</h1>
        <p className="mt-2 text-sm text-tenue">Tu web, tu contenido y tu diseño, en un solo sitio.</p>

        <div className="mt-8 flex flex-col gap-4">
          <Campo autoComplete="email" autoFocus etiqueta="Correo" onChange={(e) => setEmail(e.target.value)} required type="email" value={email} />
          <Campo autoComplete="current-password" etiqueta="Contraseña" onChange={(e) => setPassword(e.target.value)} required type="password" value={password} />
          {mensaje && <Aviso tono="error">{mensaje}</Aviso>}
          <Boton cargando={entrar.isPending} className="mt-1 w-full" tipo="primario" type="submit">
            Entrar
            {!entrar.isPending && <ArrowRight className="size-4" />}
          </Boton>
          <Link className="self-center text-[13px] text-violeta hover:underline" state={{ email }} to="/olvide">
            ¿Has olvidado tu contraseña?
          </Link>
          {marca()?.registro && (
            <Link className="self-center text-[13px] text-violeta hover:underline" to="/crear-cuenta">
              ¿No tienes cuenta? Créala
            </Link>
          )}
        </div>
      </form>
    </PantallaDeAcceso>
  )
}
